import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { ColumnDto } from './column-dto';


export class AllColumnsResponseModel extends GlobalResponseObject{
    data?: ColumnDto[];
    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: ColumnDto[]) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}
 